import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@curves/ui-base';
import { useMainLayoutContext } from '@Local/Components/Layout/Context/MainLaydoutContext';
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE, EFFECT_CONTENT_TYPE } from '@Constants/dataEnums';
import { ALL_MOCK_SCENARIOS } from '@Local/CyclePurchase/__mocks__/cyclePurchaseEffectMocks';
import {
    EffectInfoSection,
    ProductSection,
    ShippingSection,
    ReceiverSection,
    SuspensionSection,
    TerminateSection,
    ResumeSection,
} from '@Local/CyclePurchase/Components/CyclePurchaseEffectSections';

const _effectTypeMap = new Map([
    [EFFECT_CONTENT_TYPE.ITEMS,       ProductSection],
    [EFFECT_CONTENT_TYPE.CHANGEITEMS, ProductSection],
    [EFFECT_CONTENT_TYPE.SHIPPINGDAY, ShippingSection],
    [EFFECT_CONTENT_TYPE.RECEIVER,    ReceiverSection],
    [EFFECT_CONTENT_TYPE.STOP,        SuspensionSection],
    [EFFECT_CONTENT_TYPE.QUIT,        TerminateSection],
    [EFFECT_CONTENT_TYPE.RESTOP,      ResumeSection],
]);

/**
 * [DEV ONLY] 循環變更單所有 effectType 場景預覽頁
 * 路徑：/member/test/cycle-purchase-effect/
 */
const CyclePurchaseEffectPreviewPage = () => {
    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();

    useEffect(() => {
        setHeaderType(HEADER_TYPE.DEFAULT);
        setFooterType(FOOTER_TYPE.HIDE);
        setThemeType(THEME_TYPE.DARK);
    }, [setHeaderType, setFooterType, setThemeType]);

    const [activeIndex, setActiveIndex] = useState(0);
    const current = ALL_MOCK_SCENARIOS[activeIndex];
    const { data: sourceData } = current;

    return (
        <Box style={{ minHeight: '100%' }}>
            {/* 場景選擇列 */}
            <Box style={{ background: 'rgba(0,0,0,0.3)', padding: '12px 16px', overflowX: 'auto' }}>
                <Box style={{ display: 'flex', gap: 8, width: 'max-content' }}>
                    {ALL_MOCK_SCENARIOS.map((s, i) => (
                        <Box
                            key={i}
                            onClick={() => setActiveIndex(i)}
                            style={{
                                padding: '6px 12px',
                                borderRadius: 20,
                                background: i === activeIndex ? 'white' : 'rgba(255,255,255,0.2)',
                                color: i === activeIndex ? '#5c3d7a' : 'white',
                                fontSize: '1.2rem',
                                fontWeight: i === activeIndex ? 'bold' : 'normal',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {s.label}
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* 預覽內容 */}
            <Box style={{ maxWidth: 480, margin: '0 auto', padding: '16px 16px 32px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                <Typography style={{ fontSize: '1.3rem', color: 'rgba(255,255,255,0.6)', marginBottom: 4 }}>
                    場景 {activeIndex + 1} / {ALL_MOCK_SCENARIOS.length}：{current.label}
                </Typography>

                <EffectInfoSection sourceData={sourceData} />

                {(sourceData.effectType ?? []).map((type) => {
                    const Component = _effectTypeMap.get(type);
                    if (!Component) return null;
                    return <Component key={type} sourceData={sourceData} />;
                })}
            </Box>
        </Box>
    );
};

export default CyclePurchaseEffectPreviewPage;
